@if (!loadingPage()) {
  <div class="page">
    <div class="header">
      <h1 class="header-title">
        <mat-icon>payments</mat-icon>
        <span>Financiën</span>
      </h1>
      @if (tabs[selectedIndex()].key === 'audits') {
        <div class="export-button">
          <button mat-raised-button (click)="exportFilteredAudits()" [class.spinner]="processing()">
            <mat-icon>download</mat-icon><span>Exporteren</span>
          </button>
        </div>
      }
    </div>
    <div class="content">
      <mat-tab-group
        [selectedIndex]="selectedIndex()"
        (selectedIndexChange)="selectedIndex.set($event); updateUrl()"
        preserveContent="true"
      >
        @for (tab of tabs; track tab; let i = $index) {
          @if (
            tabs[i].key === 'audits' ||
            dataStore.orgUser.roles?.includes(Role.Administrator) ||
            dataStore.rootUser?.rights === 'admin'
          ) {
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>{{ tab.icon }}</mat-icon>
                <span>{{ tab.name }}</span>
              </ng-template>
              <ng-template matTabContent>
                @switch (i) {
                  @case (0) {
                    <app-audit #tab></app-audit>
                  }
                  @case (1) {
                    <app-debit-orders #tab></app-debit-orders>
                  }
                  @case (2) {
                    <app-payment-plans #tab></app-payment-plans>
                  }
                }
              </ng-template>
            </mat-tab>
          }
        }
      </mat-tab-group>
    </div>
  </div>
}
@if (loadingPage()) {
  <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
